import React, {useEffect, useRef, useState} from "react";
import {apiGetCaseInstance, apiGetCoderNotesByPatientMrn} from "../../utils/api";
import {CircularProgress, Popover} from "@mui/material";
import CoderNoteIcon from "../../../public/assets/icons/comments.svg";
import CoderNotesRowPopover from "./CoderNotesRowPopover";
import {makeStyles} from '@mui/styles'

type Props = {
    coderNotes: AmplifyAPI.CoderNoteRow[]
    patientMrn?: string
    accession?: string
}

const useStyles = makeStyles((theme) => ({
    popover: {
        pointerEvents: 'none',
    },
    popoverContent: {
        pointerEvents: 'auto',
    }
}));

const CoderNotesRowItem = (props: Props) => {
    const popoverAnchor = useRef(null);
    const [openedPopover, setOpenedPopover] = useState(false)
    const classes = useStyles();
    
    const {coderNotes, patientMrn, accession} = props;
    const [loading, setLoading] = useState(false);

    const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
        setOpenedPopover(true)
    };

    const handlePopoverClose = () => {
        setOpenedPopover(false)
    };
    
    if (loading) {
        return (
            <div
                style={{width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center"}}>
                <CircularProgress color="inherit" size={20}/>
            </div>
        );
    }

    if (!coderNotes || !coderNotes.length) {
        return <div></div>
    }

    return (
        <div style={{width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center"}}>
            <img
                ref={popoverAnchor}
                aria-owns={open ? 'mouse-over-popover' : undefined}
                aria-haspopup="true"
                onMouseEnter={handlePopoverOpen}
                onMouseLeave={handlePopoverClose}
                src={CoderNoteIcon} 
                alt="Coder Note"
            />
            
            <Popover
                id="mouse-over-popover"
                sx={{
                    pointerEvents: 'none',
                }}
                className={classes.popover}
                classes={{
                    paper: classes.popoverContent,
                }}
                open={openedPopover}
                anchorEl={popoverAnchor.current}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                onClose={handlePopoverClose}
                disableRestoreFocus
                PaperProps={{onMouseEnter: handlePopoverOpen, onMouseLeave: handlePopoverClose}}
            >
                <CoderNotesRowPopover
                    coderNotes={coderNotes}
                    patientMrn={patientMrn}
                    accession={accession}
                />
            </Popover>
        </div>
    );
};

export default React.memo(CoderNotesRowItem);